import { t } from '@lingui/core/macro';
import { Select } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { useEsigningProviderMetadata } from 'app/domains/esigning/hooks/useEsigningProviderMetadata';
import { EsigningProviderAuthenticationModeSlug, EsigningRecipientType } from 'shared/domains/apollo/generated/types';
import { ErrorMessage } from 'shared/domains/forms/components/ErrorMessage';
import { FieldWrapper } from '../../styled';
export function RoleSelect() {
    const [field, meta, helpers] = useField('type');
    const [, , { setValue: setTitle }] = useField('title');
    const [, , { setValue: setAuthenticationMode }] = useField('authenticationMode');
    const { properties: { canUseApprovers }, } = useEsigningProviderMetadata();
    const error = Boolean(meta.touched && meta.error);
    const handleChange = (event) => {
        const type = event.target.value;
        if (type === EsigningRecipientType.Viewer) {
            setTitle(undefined);
            setAuthenticationMode(undefined, false);
        }
        else if (type === EsigningRecipientType.Approver) {
            setTitle('');
            setAuthenticationMode(undefined, false);
        }
        else {
            setTitle('');
            setAuthenticationMode(EsigningProviderAuthenticationModeSlug.Email, false);
        }
        helpers.setValue(type, false);
    };
    return (<FieldWrapper>
      <Select stretch invalid={error} {...field} value={field.value} onChange={handleChange} label={t({ comment: 'Signing party form field - Role', message: 'Role' })}>
        <option value={EsigningRecipientType.Signatory}>
          {t({ comment: 'Signing party role - Signing', message: 'Signing' })}
        </option>
        {canUseApprovers && (<option value={EsigningRecipientType.Approver}>
            {t({ comment: 'Signing party role - Approver', message: 'Approver' })}
          </option>)}
        <option value={EsigningRecipientType.Viewer}>
          {t({ comment: 'Signing party role - Non-Signing', message: 'Non-Signing' })}
        </option>
      </Select>
      <ErrorMessage name="cc"/>
    </FieldWrapper>);
}
